import styles from './ChartDemand.module.css'
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    ScatterController,
    BubbleController,
    TimeScale,
    TimeSeriesScale,
    Filler
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import { Chart } from 'react-chartjs-2'
import { CircularProgress } from '@mui/material'
import 'chartjs-adapter-luxon'

interface ChartDemandProps {
    data?: any,
    options?: any,
    loading: boolean,
    monitorId?: number,
}

ChartJS.register(
    annotationPlugin,
    Filler,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    ScatterController,
    BubbleController,
    BarController,
    TimeScale,
    TimeSeriesScale
);

export const ChartDemand = (props: ChartDemandProps): JSX.Element => {
    const {
        data,
        options,
        loading = true
    } = props;

    const render = () => {
        if (loading) {
            return (
                <CircularProgress
                    color="success"
                />
            )
        }

        return (
            <Chart
                type='line'
                data={data}
                options={options}
            >
            </Chart>
        )
    }

    return (
        <div className={styles.ChartDemand}>
            <div className={styles.ChartDemand__ChartContainer}>
                {
                    render()
                }
            </div>
        </div>
    )
}